"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetAvailableRewardShopPoints = void 0;
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ShoppingContextLoadedEvent = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _react = require("react");
var _useGlobalEvents = require("./useGlobalEvents");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useGetAvailableRewardShopPoints = ({
  productLoyaltyRedeemPoints,
  remainingPoints
} = {}) => {
  const [current, setCurrent] = (0, _react.useState)(remainingPoints ?? 0);
  const onBasketUpdatedOrShoppingContextLoaded = (0, _react.useCallback)(event => {
    if (event.detail.shoppingBag.availableRewardShopPoints > 0) {
      setCurrent(event.detail.shoppingBag.availableRewardShopPoints);
    } else {
      setCurrent(event.detail.shoppingBag.vipLoyalty?.remainingPoints ?? 0);
    }
  }, []);
  const events = (0, _react.useMemo)(() => [{
    name: BasketUpdatedEvent.Name,
    listener: onBasketUpdatedOrShoppingContextLoaded
  }, {
    name: ShoppingContextLoadedEvent.Name,
    listener: onBasketUpdatedOrShoppingContextLoaded
  }], [onBasketUpdatedOrShoppingContextLoaded]);
  (0, _useGlobalEvents.useGlobalEvents)(events);
  (0, _react.useEffect)(() => {
    if (productLoyaltyRedeemPoints !== undefined && remainingPoints === undefined) {
      window.dispatchEvent(new CustomEvent(RequestShoppingContextEvent.Name));
    }
  }, [productLoyaltyRedeemPoints, remainingPoints]);
  return current;
};
exports.useGetAvailableRewardShopPoints = useGetAvailableRewardShopPoints;
//# sourceMappingURL=useGetAvailableRewardShopPoints.js.map